<template>
  <div>
    <v-toolbar color="secondary" dark>
      <v-btn icon color="primary" @click.stop="toggleDrawerRight()">
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-toolbar-title light>Workflow</v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="currentWorkflow.status" vertical>
      <v-stepper-step :complete="currentWorkflow.status >= 0" step="0">Audit freigeben</v-stepper-step>

      <v-stepper-content step="0">
        <v-card color="grey lighten-1" class="mb-5" height="200px">
          <v-textarea outline label="Kommentar" height="200px" name="name" style="height: 200px"></v-textarea>
        </v-card>
        <v-btn color="primary" @click="nextAuditStatus(1)">Continue</v-btn>
        <v-btn flat @click="toggleDrawerRight()">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="currentWorkflow.status >= 1" step="1">Vorbereitung abschließen</v-stepper-step>

      <v-stepper-content step="1">
        <v-card color="grey lighten-1" class="mb-5" height="200px">
          <v-textarea outline label="Kommentar" height="200px" name="name" style="height: 200px"></v-textarea>
        </v-card>
        <v-btn color="primary" @click="nextAuditStatus(2)">Continue</v-btn>
        <v-btn flat @click="toggleDrawerRight()">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="currentWorkflow.status >= 2" step="2">Durchführung abschließen</v-stepper-step>

      <v-stepper-content step="2">
        <v-card color="grey lighten-1" class="mb-5" height="200px">
          <v-textarea outline label="Kommentar" height="200px" name="name" style="height: 200px"></v-textarea>
        </v-card>
        <v-btn color="primary" @click="nextAuditStatus(3)">Continue</v-btn>
        <v-btn flat @click="toggleDrawerRight()">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="currentWorkflow.status >= 3" step="3">Nachbereitung abschließen</v-stepper-step>

      <v-stepper-content step="3">
        <v-card color="grey lighten-1" class="mb-5" height="200px">
          <v-textarea outline label="Kommentar" height="200px" name="name" style="height: 200px"></v-textarea>
        </v-card>
        <v-btn color="primary" @click="nextAuditStatus(4)">Continue</v-btn>
        <v-btn flat @click="toggleDrawerRight()">Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-step
        step="4"
        :complete="currentWorkflow.status >= 4"
      >Audit abschließen und Report versenden</v-stepper-step>

      <v-stepper-content step="4">
        <v-card color="grey lighten-1" class="mb-5" height="200px">
          <v-textarea outline label="Kommentar" height="200px" name="name" style="height: 200px"></v-textarea>
        </v-card>
        <v-btn color="primary" @click="nextAuditStatus(5)">Continue</v-btn>
        <v-btn flat @click="toggleDrawerRight()">Cancel</v-btn>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { api as appApi } from "@/store/modules/app";
import { api } from "@/store/modules/audits";
import { api as auditApi } from "@/store/modules/audit";

export default {
  computed: {
    ...mapGetters(auditApi.namespace, [
      auditApi.getters.getAuditId,
      auditApi.getters.getAuditDocumentData
    ]),
    currentAudit() {
      console.log("current Audit computing");
      const audit = this.getAuditDocumentData;

      return audit;
    },
    currentWorkflow() {
      console.log("Workflow Status", this.currentAudit.workflow);
      return this.currentAudit.workflow;
    }
  },
  methods: {
    ...mapActions(api.namespace, [api.actions.updateAuditStatus]),
    ...mapActions(appApi.namespace, [appApi.actions.toggleDrawerRight]),
    nextAuditStatus(id) {
      //const workflow = { status: "id", description: this.getStatus(id).description }

      let route = "auditpreparation";

      switch (id) {
        case 0:
          break;
        case 1:
          break;
        case 2:
          route = "auditexecution";
          break;
        case 3:
          route = "auditwrapup";
          break;
        case 4:
          route = "auditreporting";
          break;
        case 5:
          route = "auditreporting";
          break;
      }

      const workflow = { status: String(id) };

      const payload = {
        audit_id: this.getAuditId,
        data: workflow
      };

      console.log("Payload", payload);
      this.updateAuditStatus(payload);
      this.toggleDrawerRight();
      const audit_id = this.$route.params.auditId;
      this.$router.push({ path: `/audit/${audit_id}/${route}` });
    }
  }
};
</script>
